import { createPlugin } from '#pplx/frontend/composer-sdk/plugins/createPlugin.js';
/**
 * Companion to `createPlugin` for plugins that take live runtime props. It
 * defines the plugin shape once, then returns a `factory(props)` whose every
 * call yields a fresh instance carrying those props (under a stable id) in the
 * normal `plugins` array — no external prop map or store to mirror.
 *
 * Use `createPlugin` for static/propless plugins (one frozen shared instance);
 * reach for `createPluginFactory` when a plugin needs live props that change
 * over the surface's lifetime. Both take the same `capabilities` shape.
 */
export function createPluginFactory(config) {
    if (!config.name) {
        throw new Error('createPluginFactory: `name` is required and must be non-empty.');
    }
    // Build (and validate) the shared, frozen plugin shape once; every instance reuses it and only
    // layers its own props on top. Freeze each instance too so a stray mutation can't leak across
    // renders, mirroring createPlugin's guarantee.
    const base = createPlugin({ id: config.name, capabilities: config.capabilities });
    const getHasContent = config.hasContent;
    // Stable `base.id` across every call → same React key in SlotHost → in-place reconciliation
    // (no remount; local state + entry animations survive). Layer only `props` onto the
    // `createPlugin`-produced base so the canonical plugin fields stay defined in one place.
    return (props) => Object.freeze({
        ...base,
        ...(getHasContent === undefined ? {} : { hasContent: getHasContent(props) }),
        props,
    });
}
//# sourceMappingURL=createPluginFactory.js.map